import React, { PureComponent } from 'react';

import { Badge } from 'reactstrap';

import Table from '../../table/Table'
import moment from 'moment'

export default class TrainingTable extends PureComponent {

    render(){
        return(
        <div style={{overflowY: 'auto', maxHeight: '290px'}}>
                <Table className='table--bordered table-hover' responsive striped>
                <thead>
                    <tr>
                    <th>Name</th>
                    <th>{this.props.subModule}</th>
                    {this.props.subModule== "Security" ? <th>This Month's</th> : null}
                    <th>Overall Score</th>
                    </tr>
                </thead>
                <tbody>
                {this.props.trainingStats.map((userStat, i) => {
                    return<tr key={i}>
                    <td>{userStat.name}</td>
                    <td>
                        <Badge
                        color={
                            userStat.quizCompleted ? 'success' : 'danger'   
                        }>{userStat.quizCompleted ? 'Yes' : 'No'}</Badge></td>
                    {this.props.subModule == "Security" ? <td><Badge
                        color={
                            userStat.completedMonthlyQuizzes.includes(moment().format("MMMM-YYYY")) ? 'success' : 'danger'   
                        }>{userStat.completedMonthlyQuizzes.includes(moment().format("MMMM-YYYY")) ? 'Yes' : 'No'}</Badge></td> : null}
                    <td>{(userStat.totalMonthlyQuizScore + userStat.overallScore)}</td>
                    </tr>
                })}
                </tbody>
                </Table>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/compliance/components/TrainingTable.js